<template>
    <div>
        <div v-if="order.is_paid">
            <span>{{ __('orders.payment.paid_through', {through: order.integration.name}) }}</span>
            <table class="mt-3">
                <tr>
                    <td class="pr-2 font-weight-bold">{{ __('general.payment') }}-ID:</td>
                    <td>{{ order.payment.provider_payment_id }}</td>
                </tr>
                <tr>
                    <td class="pr-2 font-weight-bold">{{ __('general.status') }}:</td>
                    <td>
                        <span v-if="order.payment.state === 'paid'">
                            <i class="fas fa-check" />
                            {{ __('orders.paid') }}
                        </span>
                        <span v-else>
                            <i class="fas fa-times" />
                            {{ __('orders.unpaid') }}
                        </span>
                    </td>
                </tr>
            </table>
        </div>
        <div v-else>
            <span>{{ __('orders.payment.not_yet_paid') }}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        order: Object,
    },
};
</script>
